/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import mobile from 'is-mobile';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, Link } from 'react-router-dom';
import { Grid, Badge, IconButton } from '@material-ui/core';
import { Logo, Icon } from '../elements';
import { Menu } from '../components';
import BreadcrumbsComponent from '~/components/Breadcrumbs';
import { logoutUser } from '~/store/modules/user/actions';
import devices from '~/styles/devices';
import { BreadcrumbsContext } from '~/providers/BreadcrumbsProvider';
import { openModal } from '~/store/modules/modal/actions';
import { getNewNotifications } from '~/store/modules/newNotifications/actions';
import axios from '../config/axios';
import { JVCEF } from '~/config/constants';

const LinkLogo = styled.a`
  margin-right: 33px;
`;
const Breadcrumbs = styled(BreadcrumbsComponent)`
  display: none;
  @media (min-width: ${devices.mobile}) {
    display: block;
  }
`;
const NotificationsButton = styled(IconButton)`
  margin-right: 30px !important;
  width: 48px !important;
  color: white !important;
`;

const Header = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const breadcrumbs = useContext(BreadcrumbsContext);
  const { values } = breadcrumbs;
  const name = useSelector(state => state?.user?.name);
  const issuer = useSelector(state => state?.issuer);

  const newNotifications = useSelector(state => state?.newNotifications?.count);
  const user = useSelector(state => state?.user);
  const logo = useSelector(state => state?.issuer?.logo);

  function handleLogout() {
    axios.defaults.headers.common.Authorization = '';
    sessionStorage.removeItem('token');
    dispatch(logoutUser());
    history.push('/login');
  }

  useEffect(() => {
    dispatch(getNewNotifications());
    // eslint-disable-next-line
  }, []);

  return (
    <header>
      <Grid container spacing={2} alignItems="center" justify="space-between">
        <Grid style={{ display: 'flex' }} item>
          <LinkLogo href="#/home">
            {issuer?.name === JVCEF && mobile() ? (
              <Logo alt={logo?.alt} src={logo?.src} />
            ) : issuer?.name === JVCEF ? (
              <Logo alt={logo?.alt} src={logo?.src2} />
            ) : (
              <Logo alt={logo?.alt} src={logo?.src} />
            )}
          </LinkLogo>
          {values?.label && <Breadcrumbs values={values} />}
        </Grid>
        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
          {!user?.firstAccess && (
            <Grid item>
              <NotificationsButton
                className="notificacoes-step"
                component={Link}
                to="/notificacoes"
              >
                <Badge badgeContent={newNotifications} color="error">
                  <Icon icon={[newNotifications ? 'fas' : 'fal', 'bell']} />
                </Badge>
              </NotificationsButton>
            </Grid>
          )}
          <Grid item>
            <Menu
              onClick={() => dispatch(openModal('quick_search'))}
              firstName={name?.toLowerCase()}
              logout={handleLogout}
            />
          </Grid>
        </Grid>
      </Grid>
    </header>
  );
};

export default Header;
